import Vue from 'vue'
import Vuex from 'vuex'

import JSEncrypt from 'jsencrypt'
import publicKey from '@/data/public-key.js'

Vue.use(Vuex)

import backendService from '@/services/backend-service.js'

export default new Vuex.Store({
  state: {
    answers: [],
    demographics: {},
    email: ''
  },
  mutations: {
    age(state, age) {
      state.demographics.age = age
    },
    gender(state, gender) {
      state.demographics.gender = gender
    },
    education(state, education) {
      state.demographics.education = education
    },
    region(state, region) {
      state.demographics.region = region
    },
    email(state, email) {
      state.email = email
    },
    addAnswer(state, answer) {
      state.answers.push(answer)
    },
    resetAnswers(state) {
      state.answers = []
    }
  },
  actions: {
    submitAnswers({ state }) {
      var encrypt = new JSEncrypt()
      encrypt.setPublicKey(publicKey)
      let anonymizedUserID = encrypt.encrypt(state.email)

      let datapoints = state.answers.map(a => {
        return {
          section: a.section,
          measure: a.measure,
          relevance: a.relevance,
          active: a.active,
          question: a.question,
          answer: a.answer,
          score: a.score,

          age: state.demographics.age,
          gender: state.demographics.gender,
          region: state.demographics.region,
          education: state.demographics.education,
          anonymizedUserID: anonymizedUserID
        }
      })
      // axios.post(BACKEND_URL + '/save', datapoints, { headers: { 'X-Auth': 'think:green', 'X-Email': state.email }})
      backendService.savePollResults(datapoints, state.email)

      let score = state.answers.reduce((sum, curr) => sum += curr.score)

      localStorage.setItem('think-green:score', JSON.stringify(score))
    }
  }
})
